import addIcon from "../../../../../../../../../../../../../images/ai_image/addIcon.svg";
import { addTable, watchInput } from "../../utils/utils";

const panelBtnItems = [
  {
    id: "add",
    name: "新增",
    icon: addIcon,
    func: addTable,
  },
  { id: "watch", name: "觀看全文", icon: false, func: watchInput },
];

export default panelBtnItems;
